import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top on route change EXCEPT when only the language prefix changes.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const prev = window.__lastPath || "";
    const prevWithoutLang = prev.replace(/^\/(ar|en)(?=\/|$)/, "") || "/";
    const nextWithoutLang = pathname.replace(/^\/(ar|en)(?=\/|$)/, "") || "/";

    const isLangSwitchOnly = prev && prevWithoutLang === nextWithoutLang && prev !== pathname;

    if (!isLangSwitchOnly) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
    }

    window.__lastPath = pathname;
  }, [pathname]);

  return null;
}
